import React from "react";
import {connect} from "react-redux";


const SiteUsageActivites = (props) => {
    const {selected} = props;


    return (
        <div className="surface-0 ">
            SiteUsageActivites
        </div>
    );
}


const mapStateToProps = state => {
    return {
        selected: state.siteReducer.selectedRecord,
        //loading: state.siteDescriptionReducer.loading
    };
};

export default connect(mapStateToProps, {})(SiteUsageActivites)


